import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiMapPin, FiPhone, FiLinkedin, FiTwitter, FiFacebook } from 'react-icons/fi';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Products', path: '/products' },
    { name: 'About', path: '/about' },
    { name: 'Clients', path: '/clients' },
    { name: 'Contact', path: '/contact' },
  ];

  const productCategories = [
    'Office Stationery',
    'ICT Equipment',
    'Cleaning Supplies',
    'Construction Materials',
    'Hospitality Equipment',
    'Custom Procurement',
  ];

  return (
    <footer className="bg-dark-900 text-gray-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex flex-col items-start">
              <div className="h-[68px] flex items-center justify-center px-4 bg-white rounded-xl ring-2 ring-primary-400/20 shadow-md mb-4">
                <img
                  src="/assets/general_supplies_logo.jpg"
                  alt="NeoVam General Supplies Logo"
                  className="h-[56px] object-contain rounded-md"
                />
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Your trusted partner in business essentials. One-stop supplier of comprehensive business and institutional supplies across Tanzania.
            </p>
            <div className="flex gap-3 pt-2">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-dark-800 rounded-lg hover:bg-primary-400 hover:text-white transition-all duration-300"
                aria-label="LinkedIn"
              >
                <FiLinkedin className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-dark-800 rounded-lg hover:bg-primary-400 hover:text-white transition-all duration-300"
                aria-label="Twitter"
              >
                <FiTwitter className="w-5 h-5" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-dark-800 rounded-lg hover:bg-primary-400 hover:text-white transition-all duration-300"
                aria-label="Facebook"
              >
                <FiFacebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm hover:text-primary-400 transition-colors duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Product Categories */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Product Categories</h3>
            <ul className="space-y-2">
              {productCategories.map((category) => (
                <li key={category}>
                  <Link
                    to="/products"
                    className="text-sm hover:text-primary-400 transition-colors duration-300"
                  >
                    {category}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <FiMapPin className="w-5 h-5 text-primary-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  P.O BOX 36098<br />
                  Kigamboni, Dar es Salaam<br />
                  Tanzania
                </span>
              </li>
              <li className="flex items-center gap-3">
                <FiMail className="w-5 h-5 text-primary-400 flex-shrink-0" />
                <a
                  href="mailto:info@neovam.com"
                  className="text-sm hover:text-primary-400 transition-colors duration-300"
                >
                  info@neovam.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <FiPhone className="w-5 h-5 text-primary-400 flex-shrink-0" />
                <a
                  href="tel:+255000000000"
                  className="text-sm hover:text-primary-400 transition-colors duration-300"
                >
                  +255 746 177 230
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400 text-center sm:text-left">
              © {currentYear} NeoVam General Supplies. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link
                to="/contact"
                className="text-sm text-gray-400 hover:text-primary-400 transition-colors duration-300"
              >
                Privacy Policy
              </Link>
              <Link
                to="/contact"
                className="text-sm text-gray-400 hover:text-primary-400 transition-colors duration-300"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
